import { addSearchTerm } from "@/store";
import { useAppDispatch } from "@/store/hooks";
import { JobTaskDetailSchema } from "@augmodo/lebron-browser-client";
import { Button, CloseButton, Group, TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import React, { useCallback, useEffect, useState } from "react";

export const ProductSearch = ({
  task,
  mode,
}: {
  task: JobTaskDetailSchema;
  mode: "admin" | "viewer" | "qa";
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useAppDispatch();

  // for admin view and qa view, set the search query to the last search term
  useEffect(() => {
    const searchTerms =
      mode === "qa"
        ? task?.data?.product_association_result?.search_terms
        : task?.result?.search_terms;

    if (searchTerms?.length) {
      setSearchQuery(searchTerms[searchTerms.length - 1]);
      dispatch(addSearchTerm(searchTerms[searchTerms.length - 1]));
    }
  }, [
    task?.result?.search_terms,
    task?.data?.product_association_result?.search_terms,
  ]);

  // handle search - add the search term to the store
  const handleSearch = useCallback(
    (newQuery?: string) => {
      dispatch(
        addSearchTerm(typeof newQuery === "string" ? newQuery : searchQuery),
      );
    },
    [dispatch, searchQuery],
  );

  // handle key press - if enter is pressed, search
  const handleKeyPress = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === "Enter") {
        handleSearch();
      }
    },
    [handleSearch],
  );

  return (
    <div className="max-w-md mx-auto w-full pb-10">
      <Group gap="xs">
        <TextInput
          placeholder="Search for products..."
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.currentTarget.value)}
          onKeyPress={handleKeyPress}
          leftSection={<IconSearch size={16} />}
          className="flex-1"
          size="md"
          disabled={mode === "admin" || mode === "qa"}
          rightSection={
            mode === "viewer" ? (
              <CloseButton
                aria-label="Clear input"
                onClick={() => {
                  setSearchQuery("");
                  handleSearch("");
                }}
                style={{ display: searchQuery ? undefined : "none" }}
              />
            ) : null
          }
        />
        <Button
          onClick={() => handleSearch()}
          size="md"
          variant="filled"
          disabled={mode === "admin"}
        >
          Go
        </Button>
      </Group>
    </div>
  );
};
